import { cn } from 'noddi-ui-common';

interface ProgressBarProps {
  value: number;
  className?: string;
  wrapperClassName?: string;
}

export const NoddiProgressBar = ({ value, className, wrapperClassName }: ProgressBarProps) => {
  const normalizedValue = Math.max(0, Math.min(100, value));

  return (
    <div
      className={cn('relative w-full min-w-25 overflow-hidden rounded-full border-2 border-white', wrapperClassName)}
    >
      <div className={cn('h-2.5 bg-darkPurple', className)} style={{ width: `${normalizedValue}%` }} />
    </div>
  );
};
